export const selectShowConfirmationModal = (state: any) => state.confirmation.isShow;
export const selectConfirmationType = (state: any) => state.confirmation.confirmationType;
export const selectConfirmationGTMLabel = (state: any) => state.confirmation.gtmLabel;
export const selectConfirmationSuccessMessage = (state: any) => state.confirmation.successMessage;
export const selectConfirmationSuccessCallback = (state: any) => state.confirmation.successCallback;
